import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import { FormattedMessage, useIntl } from "react-intl";
import { editPersonnel, getCountries, getSinglePersonnel } from "store/actions";
import Loader from "components/shared/Loader";
import ImageUpload from "components/shared/ImageUpload";
import { Input } from "components/shared/FormComponents";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import Select from "react-select";
import { getId, handleImage, numberInputValidations } from "helpers/functions";
import * as pdfjs from "pdfjs-dist/build/pdf";
import server from "api/server";
const EditPersonnel = () => {
  // PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;

  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const navigate = useNavigate();
  const { id } = useParams();
  const { loading, error, singlePersonnel } = useSelector(
    (state) => state.personnels,
  );
  const { countries, loading: countriesLoading } = useSelector(
    (state) => state.countries,
  );

  const [selectedFile, setSelectedFile] = useState({
    preview: null,
    path: "",
  });
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const [customLoading, setCustomLoading] = useState(false);
  const handleSelectOptions = (options) => {
    if (options.length < 0) return [];

    return options.map((option) => {
      return {
        value: getId(option),
        label: option?.name?.[locale] || option?.name || option,
      };
    });
  };

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  // effects
  useEffect(() => {
    if (countries?.length <= 0) dispatch(getCountries());
    dispatch(getSinglePersonnel(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  useEffect(() => {
    reset({ ...singlePersonnel });

    setSelectedFile({
      preview: null,
      path: singlePersonnel?.name?.file,
    });
    setSelectedImage({
      preview: null,
      path: singlePersonnel?.image,
    });
  }, [reset, singlePersonnel]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const uploadImage = async (file) => {
    if (file?.name) {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await server().post("/upload", formData);
      return data;
    }
  };
  const readFileData = (file) => {
    return new Promise(async (resolve, reject) => {
      let response = await fetch(file);
      let data = await response.blob();
      const reader = new FileReader();
      reader.onload = (e) => {
        resolve(e.target.result);
      };
      reader.onerror = (err) => {
        reject(err);
      };
      reader.readAsDataURL(data);
    });
  };
  const handlePdfImage = async (file) => {
    // let pdfjs;

    (async function () {
      const pdfjsWorker = await import("pdfjs-dist/build/pdf.worker.entry");
      pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    })();

    const data = await readFileData(handleImage(file));
    const doc = await pdfjs.getDocument(data).promise;
    const page = await doc.getPage(1);
    var viewport = page.getViewport({ scale: 1 });
    const canvas = document.createElement("canvas");
    // var canvas = document.getElementById("the-canvas");
    var context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    // console.log("canvas", canvas);
    var task = page.render({ canvasContext: context, viewport: viewport });
    await task.promise;
    // console.log(canvas.toDataURL("image/jpeg"));
    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, "image/jpeg");
    });
    return new File([blob], "image.jpg", {
      type: "image/jpeg",
    });
    // return await pdf(handleImage(file));
  };
  const religions = [
    { ar: "الاسلام", en: "Islam" },
    { ar: "المسيحية", en: "Christianity" },
    { ar: "اليهودية", en: "Judaism" },
  ];
  const onSubmit = async (data) => {
    setCustomLoading(true);
    try {
      const matchedReligion = religions.find((r) => r.ar === data.religion);
      if (matchedReligion) {
        data.religion = matchedReligion;
      }
      data.image = selectedImage?.path || "";
      if (!data.image) {
        toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
        return;
      }
      data.name.file = selectedFile?.path;
      if (data.name.file) {
        const pathData = await uploadImage(
          await handlePdfImage(data.name.file),
        );
        data.name.pdfImage =
          process.env.REACT_APP_URL + pathData?.data?.file?.path;
      }
      dispatch(
        editPersonnel({
          id,
          data,
          navigate,
        }),
      );
    } catch (error) {
      console.log(error);
      alert(error);
      setCustomLoading(false);
    }
    setCustomLoading(false);
  };

  if (loading || countriesLoading || customLoading) return <Loader />;

  return (
    <>
      {/* <canvas
        id="the-canvas"
        // style={{ opacity: 0, visibility: "hidden" }}
      ></canvas> */}
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"editPersonnel"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={8} md={12}>
                {/* image  */}
                <Row>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"image"} />
                      </h5>
                      <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"PDF"} />
                      </h5>
                      <ImageUpload
                        accept="application/pdf"
                        selectedImage={selectedFile}
                        setSelectedImage={setSelectedFile}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="name"
                      name="name.ar"
                      register={register}
                      errors={errors}
                      rules={{
                        required: true,
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="name"
                      name="name.en"
                      register={register}
                      errors={errors}
                      rules={{
                        required: true,
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      {...numberInputValidations}
                      maxLength="2"
                      langId="age"
                      name="age"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>متاح / غير متاح للتوظيف</h5>

                      <label className="switch">
                        <input type="checkbox" {...register("available")} />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      {...numberInputValidations}
                      maxLength="6"
                      langId="monthlySalary"
                      name="salary"
                      register={register}
                      rules={{
                        required: true,
                      }}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      {...numberInputValidations}
                      maxLength="6"
                      langId="recruitmentFees"
                      name="recruitmentFees"
                      register={register}
                      rules={{
                        required: true,
                      }}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group ">
                      <h5>
                        <FormattedMessage id={"religion"} />
                      </h5>
                      <Controller
                        control={control}
                        name="religion.ar"
                        rules={{
                          required: true,
                        }}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            placeholder={
                              <FormattedMessage id={"selectReligion"} />
                            }
                            options={handleSelectOptions([
                              "الاسلام",
                              "المسيحية",
                              "اليهودية",
                            ])}
                            onChange={(selectedOption) => {
                              onChange(selectedOption?.value);
                            }}
                            value={handleSelectOptions(
                              religions?.map((r) => r.ar),
                            ).find((option) => {
                              console.log(option);
                              return option?.value === getId(value);
                            })}
                            isRtl={true}
                            isSearchable={false}
                            className="basic-single"
                            classNamePrefix="select"
                          />
                        )}
                      />
                    </div>
                  </Col>

                  {/* <Col lg={6} xs={12}>
                    <Input
                      type="date"
                      langId="date"
                      name="date"
                      register={register}
                      errors={errors}
                    />
                  </Col> */}
                  <Col lg={6} xs={12}>
                    <div className="form-group ">
                      <h5>
                        <FormattedMessage id={"country"} />
                      </h5>

                      <Controller
                        control={control}
                        name="country"
                        rules={{
                          required: false,
                        }}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            placeholder={
                              <FormattedMessage id={"selectCountry"} />
                            }
                            options={handleSelectOptions(countries)}
                            onChange={(selectedOption) => {
                              onChange(selectedOption?.value);
                            }}
                            value={handleSelectOptions(countries).find(
                              (option) => option?.value === getId(value),
                            )}
                            isRtl={true}
                            isSearchable={false}
                            className="basic-single"
                            classNamePrefix="select"
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="job"
                      name="job.ar"
                      register={register}
                      errors={errors}
                      rules={{
                        required: false,
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="job"
                      name="job.en"
                      register={register}
                      errors={errors}
                      rules={{
                        required: false,
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="languages"
                      name="experience.ar"
                      register={register}
                      errors={errors}
                      rules={{
                        required: false,
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="languages"
                      name="experience.en"
                      register={register}
                      errors={errors}
                      rules={{
                        required: false,
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="experienceYears"
                      name="name.experienceYears"
                      register={register}
                      errors={errors}
                      rules={{
                        required: false,
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      {...numberInputValidations}
                      langId="passportNumber"
                      name="passportNumber"
                      register={register}
                      errors={errors}
                      rules={{
                        required: false,
                      }}
                    />
                  </Col>

                  <Col lg={6} xs={12}>
                    <Input
                      langId="foreignExportOffice"
                      name="foreignExportOffice.ar"
                      register={register}
                      errors={errors}
                      rules={{
                        required: false,
                      }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="foreignExportOffice"
                      name="foreignExportOffice.en"
                      register={register}
                      errors={errors}
                      rules={{
                        required: false,
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        <FormattedMessage id={"saveChanges"} />
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPersonnel;
